import React from "react";
import "./style.scss";

export default function LoadPage(){
  return <div className="load-page-area">
    <div className="load-page-area-icon">
      <div className="dot"></div>
      <div className="dot"></div>
      <div className="dot"></div>
    </div>
  </div>
}